import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    // Slide in from top
    requestAnimationFrame(() => {
      this.element.style.transition = "transform 500ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 400ms ease"
      this.element.style.transform = "translateY(0)"
      this.element.style.opacity = "1"
    })

    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    clearTimeout(this.timeout)

    const el = this.element
    el.style.transition = "transform 350ms cubic-bezier(0.5, 0, 1, 0.5), opacity 250ms ease"
    el.style.transform = "translateY(-100%)"
    el.style.opacity = "0"

    el.addEventListener("transitionend", () => el.remove(), { once: true })
  }
}
